<div class="sidenav" [ngClass]="collapsed ? 'sidenav-collapsed' : ''">
  <div class="logo-container">
    <!-- <button class="logo" (click)="toggleCollapse()">R</button> -->
    <img src="assets/images/Isolation_Mode.svg" (click)="toggleCollapse()"
      style="width: 98%; padding: 20px 13px;  cursor: pointer;" *ngIf="!collapsed">
    <img src="assets/images/app-icon.png" *ngIf="collapsed" (click)="toggleCollapse()" class="logo">

    <!-- <button class="btn-close" *ngIf="!collapsed" (click)="closeSidenav()">
      <i class="bi bi-x"></i>
    </button> -->
  </div>
  <!--  <ul class="sidenav-nav">-->
  <!--    <li class="sidenav-item" *ngFor="let data of navData">-->
  <!--      <a-->
  <!--        class="sidenav-link"-->
  <!--        [class.collapsed]="collapsed"-->
  <!--        [routerLink]="[data.routeLink]"-->
  <!--        routerLinkActive="active"-->
  <!--        [routerLinkActiveOptions]="{ exact: true }"-->
  <!--      >-->
  <!--        <i class="sidenav-link-icon" [class]="data.icon"></i>-->
  <!--        <span class="sidenav-link-text" *ngIf="!collapsed">{{-->
  <!--          data.label-->
  <!--        }}</span>-->
  <!--      </a>-->
  <!--    </li>-->
  <!--  </ul>-->

  <ul class="sidenav-nav">
    <li class="sidenav-item" *ngFor="let data of navData" [hidden]="!data.enabled">
      <a class="sidenav-link" (click)="handleClick(data)" *ngIf="data.items && data.items.length > 0"
        routerLinkActive="active">
        <!-- <i class="sidenav-link-icon" [class]="data.icon"></i> -->
        <img [src]="data.icon" class="sidenav-link-icon">
        <span class="sidenav-link-text" *ngIf="!collapsed">{{
          data.label
          }}</span>
        <i *ngIf="data.items && !collapsed" class="menu-collapse-icon" [ngClass]="
            !data.expanded ? 'filled-down' : 'filled-down' 
          "></i>
        <img *ngIf="data.items && !collapsed" [src]="
            !data.expanded ? '../assets/images/filled-down.svg' : '../assets/images/filled-up.svg'">
      </a>

      <a class="sidenav-link" *ngIf="(!data.items && data.externalLink === null)" [routerLink]="[data.routeLink]"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <!-- <i class="sidenav-link-icon" [class]="data.icon"></i> -->
        <img [src]="data.icon" class="sidenav-link-icon">
        <span class="sidenav-link-text" *ngIf="!collapsed">{{
          data.label
          }}</span>
      </a>

      <a class="sidenav-link" *ngIf="(!data.items && data.externalLink === false)" [routerLink]="[data.routeLink]"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" target="_blank">
        <!-- <i class="sidenav-link-icon" [class]="data.icon"></i> -->
        <img [src]="data.icon" class="sidenav-link-icon">
        <span class="sidenav-link-text" *ngIf="!collapsed">{{
          data.label
          }}</span>
      </a>

      <a class="sidenav-link" *ngIf="(!data.items && data.externalLink === true)" [attr.href]="[data.routeLink]"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" target="_blank">
        <!-- <i class="sidenav-link-icon" [class]="data.icon"></i> -->
        <img [src]="data.icon" class="sidenav-link-icon">
        <span class="sidenav-link-text" *ngIf="!collapsed">{{
          data.label
          }}</span>
      </a>

      <div *ngIf="!collapsed && data.items && data.items.length > 0">
        <rap-sublevel-menu [data]="data" [collapsed]="!collapsed" [multiple]="multiple" [expanded]="data.expanded">
        </rap-sublevel-menu>
      </div>
    </li>

  </ul>
</div>

<!--      <rap-sublevel-menu-->
<!--        [data]="data"-->
<!--        [collapsed]="!collapsed"-->
<!--      ></rap-sublevel-menu>-->